// extracted by mini-css-extract-plugin
export var cardContainer = "_qw-0";
export var cardHeader = "_qw-2";
export var collapsedState = "_qw-3";
export var dragHandle = "_qw-5";
export var dragHandleIcon = "_qw-6";
export var dragging = "_qw-1";
export var titleArea = "_qw-4";